import { render } from "./eduResearchStat.vue?vue&type=template&id=696f91da&scoped=true"
import script from "./eduResearchStat.vue?vue&type=script&lang=js"
export * from "./eduResearchStat.vue?vue&type=script&lang=js"

import "./eduResearchStat.vue?vue&type=style&index=0&id=696f91da&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-696f91da"]])

export default __exports__